import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-application-info',
  standalone: false,
  imports: [],
  templateUrl: './application-info.component.html',
  styleUrl: './application-info.component.scss'
})
export class ApplicationInfoComponent {

  @Input() public Content: any;

  constructor(public modalRef: NgbActiveModal)
  { }

ngOnInit()
{
  let cintent = this.Content;
}

close()
{
    this.modalRef.dismiss();
}



}
